import React from "react";
import ReviewsRatingIcon from "assets/images/svgs/reviewStarSvg.svg";
import CupRatingIcon from "assets/images/svgs/cupIconSvg.svg";
import attende1 from "assets/images/others/host-side-images/attende1.png";
import attende2 from "assets/images/others/host-side-images/attende2.png";
import attende3 from "assets/images/others/host-side-images/attende3.png";
import attende4 from "assets/images/others/host-side-images/attende4.png";
interface Review {
  id: number;
  name: string;
  date: string;
  review: string;
  rating: number;
  avatar: string;
  ratingIcon: string;
  cupRatingIcon: string;
}
const reviews: Review[] = [
  {
    id: 1,
    name: "Bella Throne",
    date: "Today",
    review:
      "Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum, Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum",
    rating: 4.9,
    avatar: attende1,
    ratingIcon: ReviewsRatingIcon,
    cupRatingIcon: CupRatingIcon,
  },
  {
    id: 2,
    name: "Bella Throne",
    date: "Today",
    review:
      "Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum, Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum",
    rating: 4.9,
    avatar: attende2,
    ratingIcon: ReviewsRatingIcon,
    cupRatingIcon: CupRatingIcon,
  },
  {
    id: 3,
    name: "Bella Throne",
    date: "Today",
    review:
      "Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum, Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum",
    rating: 4.9,
    avatar: attende2,
    ratingIcon: ReviewsRatingIcon,
    cupRatingIcon: CupRatingIcon,
  },
  {
    id: 3,
    name: "Bella Throne",
    date: "Today",
    review:
      "Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum, Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum",
    rating: 4.9,
    avatar: attende2,
    ratingIcon: ReviewsRatingIcon,
    cupRatingIcon: CupRatingIcon,
  },
];
const Reviews = () => {
  return (
    <div className="my-10">
      <div className="border-[0.3px] border-labelTextColor  p-6  rounded-lg shadow-sm flex flex-col gap-10">
        {reviews.map((review) => (
          <div
            key={review.id}
            className="flex md:flex-nowrap flex-wrap items-start justify-between "
          >
            {/* Left Column - User Info and Review */}
            <div className="flex flex-col gap-3 w-full">
              {/* User Info */}
              <div className="flex items-center gap-2">
                <img
                  src={review.avatar}
                  alt="Avatar"
                  className="w-10 h-10 rounded-full"
                />
                <div>
                  <h4 className="font-semibold text-black text-lg">
                    {review.name}
                  </h4>
                  <p className="text-sm text-labelTextColor">{review.date}</p>
                </div>
              </div>

              {/* Review Text */}
              <div>
                <p className="text-blackie">{review.review}</p>
              </div>
            </div>

            {/* Right Column - Rating and Cup Icon */}
            <div className="flex flex-col gap-2 md:gap-3 md:items-end md:px-6 mt-3">
              {/* Rating */}
              <div className="flex items-center space-x-2">
                {[...Array(5)].map((_, i) => (
                  <img
                    key={i}
                    src={review.ratingIcon}
                    alt="Star Icon"
                    className="w-6 h-6"
                  />
                ))}
                <span className="ml-2 text-labelTextColor">
                  ({review.rating})
                </span>
              </div>

              {/* Cup Rating */}
              <div>
                <img
                  src={review.cupRatingIcon}
                  alt="Cup Rating Icon"
                  className="w-14 h-14" // Adjust the size if necessary
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Reviews;
